import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App';
import SignIn from './routes/SignIn';
import Dashboard from './routes/Dashboard';
import Editor from './routes/Editor';
import Viewer from './routes/Viewer';
import Install from './routes/Install';
import Admin from './routes/Admin';
import NotFound from './routes/NotFound';
import './index.css';

console.info(`[snippits] build ${__BUILD_ID__}`);

const router = createBrowserRouter([
  {
    element: <App />,
    children: [
      { path: '/', element: <Dashboard /> },
      { path: '/signin', element: <SignIn /> },
      { path: '/app', element: <Dashboard /> },
      { path: '/install', element: <Install /> },
      { path: '/admin', element: <Admin /> },
      { path: '/editor/:draftId', element: <Editor /> },
      { path: '/s/:shortId', element: <Viewer /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
